module.exports = __webpack_public_path__ + "img/beyond-logo-white.e35fcb21.svg";